import Swiper from 'swiper/bundle';

export const swiper = new Swiper('.swiper-container',{
    autoHeight: true,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    speed: 3000,
    pagination: {
        el: '.swiper-pagination', //ページネーションの要素
        type: 'bullets', //ページネーションの種類
        clickable: true, //クリックに反応させる
      },
});
